(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rqst-cart-layout')) {
    customElements.define('rqst-cart-layout', class extends HTMLElement {
      connectedCallback() {
        this.cart = this.closest('.shopify-section')?.querySelector('[data-cart-drawer]');
        this.header = document.querySelector('header-component');
        if (!this.cart) return;
        this.media = window.matchMedia('(max-width: 1023px)');
        this.isMobile = this.media.matches;
        this.icons = [];
        this.bindIcons();
        this.onOpen = () => {
          if (this.media.matches && this.header?.dataset.position !== 'fixed') {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          }
          this.measure();
          this.focusFrame = requestAnimationFrame(() => this.updateControls());
        };
        this.onClose = () => this.updateControls(false);
        this.onResize = () => {
          const enteredMobile = this.media.matches && !this.isMobile;
          this.isMobile = this.media.matches;
          if (this.cart.classList.contains('is-open')) {
            if (enteredMobile) this.onOpen();
            this.measure();
            this.updateControls();
          }
        };
        this.onKeyDown = (event) => {
          if (event.key === 'Escape' && this.media.matches && this.cart.classList.contains('is-open') && event.target.closest('header-component [data-cart-drawer-toggle]')) {
            event.preventDefault();
            this.cart.closeCartDrawer?.();
            return;
          }
          if (event.key !== 'Enter' || !event.target.matches('[data-discount-input]')) return;
          event.preventDefault();
          this.cart.querySelector('[data-apply-discount]')?.click();
        };
        this.onDiscountClick = (event) => {
          if (event.target.closest('[data-apply-discount]')) {
            this.resetDiscountFeedback();
            this.cart.clearDiscountErrors?.();
          }
        };
        this.onDiscountInput = (event) => {
          if (event.target.matches('[data-discount-input]')) this.resetDiscountFeedback();
        };
        this.onSectionLoad = () => {
          this.bindIcons();
          this.onResize();
        };
        this.onCartUpdate = () => { if (this.cart.classList.contains('is-open')) this.updateControls(); };
        this.discountObserver = new MutationObserver(() => this.showDiscountFeedback());
        this.discountObserver.observe(this.cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        document.addEventListener('theme:cart:open', this.onOpen);
        document.addEventListener('theme:cart:close', this.onClose);
        document.addEventListener('theme:cart:added', this.onCartUpdate);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('keydown', this.onKeyDown);
        this.cart.addEventListener('click', this.onDiscountClick, true);
        this.cart.addEventListener('input', this.onDiscountInput);
        window.addEventListener('resize', this.onResize);
        window.visualViewport?.addEventListener('resize', this.onResize);
        this.headerObserver = new ResizeObserver(this.onResize);
        if (this.header) this.headerObserver.observe(this.header);
      }
      bindIcons() {
        document.querySelectorAll('header-component [data-cart-drawer-toggle]').forEach((button) => {
          const original = button.querySelector('svg');
          if (!original || original.hasAttribute('data-rqst-cart-icon')) return;
          const icon = original.cloneNode(false);
          icon.setAttribute('data-rqst-cart-icon', '');
          const bag = document.createElementNS('http://www.w3.org/2000/svg', 'g');
          bag.setAttribute('class', 'rqst-cart-bag');
          original.childNodes.forEach((node) => bag.appendChild(node.cloneNode(true)));
          icon.appendChild(bag);
          ['first', 'second'].forEach((side) => {
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            line.setAttribute('d', side === 'first' ? 'M49.331 49.331l93.338 93.338' : 'M142.669 49.331l-93.338 93.338');
            line.setAttribute('stroke', 'currentColor');
            line.setAttribute('stroke-linecap', 'round');
            line.setAttribute('class', `rqst-cart-cross rqst-cart-cross--${side}`);
            icon.appendChild(line);
          });
          this.icons.push({ button, original, icon, label: button.getAttribute('aria-label') });
          original.replaceWith(icon);
        });
      }
      updateControls(open = this.cart.classList.contains('is-open')) {
        this.icons.forEach(({ button, label }) => {
          if (open && this.media.matches) button.setAttribute('aria-label', this.dataset.closeLabel);
          else if (label === null) button.removeAttribute('aria-label');
          else button.setAttribute('aria-label', label);
        });
        if (!open) return;
        const state = window.theme?.a11y?.state;
        if (!state) return;
        const trigger = this.icons.find(({ button }) => button.offsetWidth && button.offsetHeight)?.button;
        const focusable = Array.from(this.cart.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex^="-"])')).filter((element) => element.offsetWidth && element.offsetHeight);
        state.firstFocusable = this.media.matches && trigger ? trigger : focusable[0];
        state.lastFocusable = focusable[focusable.length - 1];
      }
      resetDiscountFeedback() {
        clearTimeout(this.discountTimer);
        this.discountFeedbackHandled = false;
        this.cart.querySelector('.rqst-cart-discount__field')?.classList.remove('is-rejected');
        this.cart.querySelector('[data-discount-input]')?.removeAttribute('aria-invalid');
      }
      showDiscountFeedback() {
        const error = this.cart.querySelector('[data-discount-error-message]');
        if (!error || error.classList.contains('hidden') || !error.textContent.trim()) {
          this.discountFeedbackHandled = false;
          return;
        }
        const rejected = this.cart.discountError || error.textContent === window.theme?.strings?.discount_already_applied;
        error.classList.toggle('rqst-cart-discount__feedback-only', Boolean(rejected));
        if (!rejected || this.discountFeedbackHandled) return;
        this.discountFeedbackHandled = true;
        const field = this.cart.querySelector('.rqst-cart-discount__field');
        this.cart.querySelector('[data-discount-input]')?.setAttribute('aria-invalid', 'true');
        field?.classList.add('is-rejected');
        clearTimeout(this.discountTimer);
        this.discountTimer = setTimeout(() => field?.classList.remove('is-rejected'), 1100);
      }
      measure() {
        this.header = document.querySelector('header-component');
        const top = this.media.matches ? Math.max(0, this.header?.getBoundingClientRect().bottom || 0) : 0;
        const viewport = window.visualViewport?.height || window.innerHeight;
        this.cart.style.setProperty('--rqst-cart-top', `${top}px`);
        this.cart.style.setProperty('--rqst-cart-viewport', `${viewport}px`);
        document.documentElement.style.setProperty('--rqst-cart-top', `${top}px`);
      }
      disconnectedCallback() {
        document.removeEventListener('theme:cart:open', this.onOpen);
        document.removeEventListener('theme:cart:close', this.onClose);
        document.removeEventListener('theme:cart:added', this.onCartUpdate);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        document.removeEventListener('keydown', this.onKeyDown);
        this.cart?.removeEventListener('click', this.onDiscountClick, true);
        this.cart?.removeEventListener('input', this.onDiscountInput);
        window.removeEventListener('resize', this.onResize);
        window.visualViewport?.removeEventListener('resize', this.onResize);
        this.headerObserver?.disconnect();
        this.discountObserver?.disconnect();
        clearTimeout(this.discountTimer);
        cancelAnimationFrame(this.focusFrame);
        this.icons?.forEach(({ button, original, icon, label }) => {
          icon.replaceWith(original);
          if (label === null) button.removeAttribute('aria-label');
          else button.setAttribute('aria-label', label);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('rqst-footer-newsletter')) {
  customElements.define('rqst-footer-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.dataset.animate !== 'true' || this.motionQuery.matches || this.revealed) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motionQuery.addEventListener('change', () => {
        if (this.motionQuery.matches) this.cleanup();
      }, {signal});
      this.addEventListener('focusin', () => this.cleanup(), {signal});
      this.visibilityObserver = new IntersectionObserver(() => this.reveal(), {threshold: 0.1});
      this.visibilityObserver.observe(this);
      const section = this.closest('.shopify-section');
      if (section) {
        this.footerObserver = new MutationObserver(() => this.reveal());
        this.footerObserver.observe(section, {attributes: true, attributeFilter: ['class']});
      }
    }
    reveal() {
      if (this.revealed || this.motionQuery.matches) return;
      const bounds = this.getBoundingClientRect();
      const visibleHeight = Math.min(bounds.bottom, innerHeight) - Math.max(bounds.top, 0);
      if (getComputedStyle(this).visibility === 'hidden' || visibleHeight < Math.min(bounds.height * 0.1, 40)) return;
      this.revealed = true;
      this.visibilityObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.revealAnimation = this.animate([
        {opacity: 0, transform: 'translateY(20px)'},
        {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 700, delay: 150, easing: 'ease-in-out', fill: 'backwards'});
    }
    cleanup() {
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.footerObserver?.disconnect();
      this.revealAnimation?.cancel();
    }
    disconnectedCallback() {this.cleanup();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rqst-logo-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rqst-logo-slider')) {
    customElements.define('rqst-logo-slider', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.rqst-logo-slider__viewport');
        this.track = this.querySelector('.rqst-logo-slider__track');
        this.group = this.querySelector('.rqst-logo-slider__group');
        this.originalItems = Array.from(this.group.children);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onResize = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.buildLoop());
        };
        this.onBlockSelect = event => {
          if (!this.contains(event.target)) return;
          this.setAttribute('data-editor-paused', '');
          this.removeAttribute('data-ready');
          this.clearClones();
          event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
        };
        this.onBlockDeselect = () => {
          this.removeAttribute('data-editor-paused');
          this.onResize();
        };
        this.motion.addEventListener('change', this.onResize);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
        if (window.Shopify && window.Shopify.designMode) {
          this.addEventListener('shopify:block:select', this.onBlockSelect);
          this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
        this.buildLoop();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.onResize(); });
      }
      clearClones() {
        this.track.querySelectorAll('[data-logo-clone]').forEach(node => node.remove());
      }
      clone(node) {
        const clone = node.cloneNode(true);
        clone.setAttribute('data-logo-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          if (element.matches('a, button, [tabindex]')) element.setAttribute('tabindex', '-1');
        });
        clone.removeAttribute('aria-labelledby');
        return clone;
      }
      buildLoop() {
        if (this.hasAttribute('data-editor-paused')) return;
        this.removeAttribute('data-ready');
        this.clearClones();
        this.viewport.scrollLeft = 0;
        if (this.motion.matches || !this.originalItems.length || !this.viewport.clientWidth) return;
        const baseWidth = this.group.getBoundingClientRect().width;
        if (!baseWidth) return;
        const repeats = Math.max(1, Math.ceil(this.viewport.clientWidth / baseWidth));
        for (let repeat = 1; repeat < repeats; repeat += 1) {
          this.originalItems.forEach(item => this.group.appendChild(this.clone(item)));
        }
        const distance = this.group.getBoundingClientRect().width;
        this.track.appendChild(this.clone(this.group));
        this.style.setProperty('--rqst-logo-distance', `${distance}px`);
        this.style.setProperty('--rqst-logo-duration', `${distance / Math.max(10, Number(this.dataset.speed) || 35)}s`);
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver.disconnect();
        this.motion.removeEventListener('change', this.onResize);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.clearClones();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rqst-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rqst-mobile-menu')) {
    customElements.define('rqst-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.header = null;
        this.scroller = this.querySelector('.rqst-mobile-menu__content');
        this.media = window.matchMedia('(max-width: 1023px)');
        this.triggers = [];
        this.originalAttributes = [];
        this.bindHeader();
        this.onMouseDown = (event) => {
          if (this.media.matches && event.target.closest('[data-mobile-menu-trigger]') && document.querySelector('[data-cart-drawer].is-open')) {
            event.stopPropagation();
          }
        };
        this.onClick = (event) => {
          const trigger = event.target.closest('[data-mobile-menu-trigger]');
          if (trigger && this.media.matches) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.isOpen ? this.close(true) : this.open(trigger);
            return;
          }
          if (!this.isOpen) return;
          if (event.target.closest('[data-cart-drawer-toggle]')) this.close(false, true);
          const submenu = event.target.closest('[data-rqst-submenu-toggle]');
          if (submenu && this.contains(submenu)) {
            const expanded = submenu.getAttribute('aria-expanded') === 'true';
            submenu.setAttribute('aria-expanded', String(!expanded));
            document.getElementById(submenu.getAttribute('aria-controls')).hidden = expanded;
          }
          const link = event.target.closest('a');
          if (link && this.contains(link)) {
            const destination = new URL(link.href, window.location.href);
            if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) this.close(false, true);
          }
        };
        this.onKeyDown = (event) => {
          if (!this.isOpen || event.defaultPrevented) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close(true);
          } else if (event.key === 'Tab') {
            const selector = 'a[href],button:not([disabled]),summary,select,input:not([type="hidden"]),[tabindex="0"]';
            const focusable = [...this.header.querySelectorAll(selector), ...this.querySelectorAll(selector)].filter((element) => element.getClientRects().length && !element.closest('[inert]'));
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault(); last?.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault(); first?.focus();
            }
          }
        };
        this.onCartOpen = () => {
          if (!this.isOpen) return;
          this.close(false, true);
          const cartTrigger = this.header.querySelector('[data-cart-drawer-toggle]');
          if (cartTrigger && window.theme?.a11y) window.theme.a11y.state.trigger = cartTrigger;
        };
        this.onResize = () => {
          if (!this.media.matches) this.close(false, true);
          else if (this.isOpen) this.measure();
        };
        this.onHeaderReload = () => {
          if (this.header !== document.querySelector('header-component') || this.triggers.some((trigger) => !trigger.isConnected)) {
            this.close(false, true);
            this.bindHeader();
          }
        };
        this.onEditorSelect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId && this.media.matches) this.open(this.triggers[0]);
        };
        this.onEditorDeselect = (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) this.close(false, true);
        };
        this.onTransitionEnd = (event) => {
          if (this.isClosing && event.target === this && event.propertyName === 'transform') this.finishClose();
        };
        this.onPageShow = (event) => {
          if (event.persisted) this.close(false, true);
        };
        this.addEventListener('transitionend', this.onTransitionEnd);
        document.addEventListener('mousedown', this.onMouseDown, true);
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('theme:cart:open', this.onCartOpen);
        document.addEventListener('shopify:section:load', this.onHeaderReload);
        document.addEventListener('shopify:section:select', this.onEditorSelect);
        document.addEventListener('shopify:section:deselect', this.onEditorDeselect);
        window.addEventListener('resize', this.onResize);
        window.addEventListener('pageshow', this.onPageShow);
        window.visualViewport?.addEventListener('resize', this.onResize);
        this.headerObserver = new ResizeObserver(() => { if (this.isOpen) this.measure(); });
        if (this.header) this.headerObserver.observe(this.header);
      }
      bindHeader() {
        const header = document.querySelector('header-component');
        if (header === this.header && this.triggers.every((trigger) => trigger.isConnected)) return;
        this.releaseTriggers();
        this.headerObserver?.disconnect();
        this.header = header;
        this.triggers = Array.from(header?.querySelectorAll('[data-mobile-menu-trigger]') || []);
        this.originalAttributes = this.triggers.map((trigger) => {
          const originalIcon = trigger.querySelector('.icon-hamburger');
          let animatedIcon;
          if (originalIcon) {
            animatedIcon = originalIcon.cloneNode(false);
            animatedIcon.setAttribute('data-rqst-menu-icon', '');
            ['top', 'middle', 'bottom'].forEach((position) => {
              const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              path.setAttribute('d', 'M30 96h132');
              path.setAttribute('stroke', 'currentColor');
              path.setAttribute('stroke-linecap', 'round');
              path.setAttribute('class', `rqst-menu-bar--${position}`);
              animatedIcon.appendChild(path);
            });
            originalIcon.replaceWith(animatedIcon);
          }
          return { trigger, controls: trigger.getAttribute('aria-controls'), label: trigger.getAttribute('aria-label'), originalIcon, animatedIcon };
        });
        this.triggers.forEach((trigger) => {
          trigger.setAttribute('aria-controls', this.id);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-label', this.dataset.openLabel);
        });
        if (header) this.headerObserver?.observe(header);
      }
      releaseTriggers() {
        this.originalAttributes.forEach(({ trigger, controls, label, originalIcon, animatedIcon }) => {
          controls === null ? trigger.removeAttribute('aria-controls') : trigger.setAttribute('aria-controls', controls);
          label === null ? trigger.removeAttribute('aria-label') : trigger.setAttribute('aria-label', label);
          if (animatedIcon?.isConnected) animatedIcon.replaceWith(originalIcon);
        });
      }
      measure() {
        const bottom = Math.max(0, this.header.getBoundingClientRect().bottom);
        this.style.setProperty('--rqmm-top', `${bottom}px`);
      }
      open(trigger) {
        this.bindHeader();
        if (this.isOpen || !this.header || !this.media.matches) return;
        document.querySelector('[data-cart-drawer]')?.closeCartDrawer?.();
        this.trigger = trigger?.isConnected ? trigger : this.triggers[0];
        const reopening = this.isClosing;
        clearTimeout(this.closeTimer);
        this.isClosing = false;
        this.hidden = false;
        this.inert = false;
        this.setAttribute('aria-hidden', 'false');
        this.isOpen = true;
        document.body.classList.add('rqst-mobile-menu-open', 'js-drawer-open');
        this.measure();
        document.querySelectorAll('rqst-header-localization').forEach((localization) => localization.close?.());
        document.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
        this.triggers.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
          button.setAttribute('aria-label', this.dataset.closeLabel);
        });
        if (!reopening) this.inertElements = Array.from(document.querySelectorAll('main, .shopify-section-group-group-footer')).map((element) => ({ element, inert: element.inert }));
        this.inertElements.forEach(({ element }) => { element.inert = true; });
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.scroller }));
        this.getBoundingClientRect();
        requestAnimationFrame(() => {
          if (!this.isOpen) return;
          this.classList.add('is-open');
          this.querySelector('.rqst-mobile-menu__link')?.focus({ preventScroll: true });
        });
      }
      close(restoreFocus = false, immediate = false) {
        if (!this.isOpen && !this.isClosing) return;
        this.isOpen = false;
        this.isClosing = true;
        this.inert = true;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this.triggers.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-label', this.dataset.openLabel);
        });
        this.querySelectorAll('rqst-header-localization').forEach((localization) => localization.close?.());
        if (restoreFocus) this.trigger?.focus({ preventScroll: true });
        clearTimeout(this.closeTimer);
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.finishClose();
        else this.closeTimer = setTimeout(() => this.finishClose(), 450);
      }
      finishClose() {
        clearTimeout(this.closeTimer);
        this.isClosing = false;
        this.hidden = true;
        this.inert = false;
        document.body.classList.remove('rqst-mobile-menu-open');
        if (!document.querySelector('drawer-element.is-open')) document.body.classList.remove('js-drawer-open');
        this.inertElements?.forEach(({ element, inert }) => { element.inert = inert; });
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true }));
      }
      disconnectedCallback() {
        this.close(false, true);
        this.releaseTriggers();
        this.removeEventListener('transitionend', this.onTransitionEnd);
        document.removeEventListener('mousedown', this.onMouseDown, true);
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('theme:cart:open', this.onCartOpen);
        document.removeEventListener('shopify:section:load', this.onHeaderReload);
        document.removeEventListener('shopify:section:select', this.onEditorSelect);
        document.removeEventListener('shopify:section:deselect', this.onEditorDeselect);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onPageShow);
        window.visualViewport?.removeEventListener('resize', this.onResize);
        this.headerObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rqst-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rqst-testimonials')) {
  customElements.define('rqst-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.revealObserver?.disconnect();
      this.cancelReviewAnimations();
      this.removeClones();
      this.controller = new AbortController();
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-review]')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.cards.forEach(card => {card.dataset.reviewKey = card.dataset.blockId;});
      const signal = this.controller.signal;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionQuery.addEventListener('change', () => {
        if (this.motionQuery.matches) this.cancelReviewAnimations();
      }, {signal});
      this.classList.add('is-ready');
      this.filters.forEach(button => button.addEventListener('click', () => this.filter(button), {signal}));
      this.prev.addEventListener('click', () => this.move(-1), {signal});
      this.next.addEventListener('click', () => this.move(1), {signal});
      this.track.addEventListener('scroll', () => {
        this.updateArrows();
        clearTimeout(this.settleTimer);
        if (!this.dragging) this.settleTimer = setTimeout(() => this.finishScroll(), 140);
      }, {signal, passive: true});
      this.track.addEventListener('scrollend', () => this.finishScroll(), {signal});
      this.track.addEventListener('pointerdown', () => {
        this.dragging = true;
        clearTimeout(this.settleTimer);
      }, {signal, passive: true});
      const release = () => {
        this.dragging = false;
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.finishScroll(), 140);
      };
      window.addEventListener('pointerup', release, {signal, passive: true});
      window.addEventListener('pointercancel', release, {signal, passive: true});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-read-more]');
        if (!button || !this.contains(button)) return;
        const key = button.closest('.rqst-testimonials__card').dataset.reviewKey;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.rqst-testimonials__card').forEach(card => {
          if (card.dataset.reviewKey !== key) return;
          card.querySelector('[data-body]').classList.toggle('is-expanded', expanded);
          const control = card.querySelector('[data-read-more]');
          control.setAttribute('aria-expanded', String(expanded));
          control.querySelector('[data-more]').hidden = expanded;
          control.querySelector('[data-less]').hidden = !expanded;
        });
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {
          this.filter(this.filters[0]);
          this.track.scrollTo({left: this.position(card), behavior: 'instant'});
        }
      }, {signal});
      this.observer = new ResizeObserver(() => {
        const key = this.measureKey();
        if (key !== this.geometryKey) this.buildLoop(this.currentIndex());
        this.updateReadMore();
      });
      this.observer.observe(this.track);
      document.fonts.ready.then(() => {
        if (this.isConnected) {this.buildLoop(this.currentIndex()); this.updateReadMore();}
      });
      this.filter(this.filters.find(button => button.getAttribute('aria-pressed') === 'true') || this.filters[0], false);
      if (this.dataset.animate === 'true' && !this.motionQuery.matches) {
        this.revealObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.revealObserver.disconnect();
          this.animateReviews();
        }, {threshold: 0.1});
        this.revealObserver.observe(this.track);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.revealObserver?.disconnect();
      this.cancelReviewAnimations();
      clearTimeout(this.settleTimer);
      this.removeClones();
    }
    removeClones() {this.querySelectorAll('[data-review-clone]').forEach(card => card.remove());}
    cancelReviewAnimations() {
      this.reviewAnimations?.forEach(animation => animation.cancel());
      this.reviewAnimations = [];
    }
    animateReviews() {
      this.cancelReviewAnimations();
      if (this.dataset.animate !== 'true' || this.motionQuery.matches || this.track.hidden) return;
      const bounds = this.track.getBoundingClientRect();
      const cards = [...this.track.querySelectorAll('.rqst-testimonials__card:not([hidden])')].filter(card => {
        const rect = card.getBoundingClientRect();
        return rect.right > bounds.left + 1 && rect.left < bounds.right - 1;
      });
      cards.forEach((card, index) => {
        [...card.children].forEach(content => {
          this.reviewAnimations.push(content.animate([
            {opacity: 0, transform: 'translateX(16px)'},
            {opacity: 1, transform: 'translateX(0)'}
          ], {duration: 600, delay: index * 150, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'backwards'}));
        });
      });
    }
    position(card) {return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;}
    measureKey() {
      const visible = this.cards.filter(card => !card.hidden);
      return [this.track.clientWidth, visible[0]?.getBoundingClientRect().width || 0, visible.length].join(':');
    }
    currentIndex() {
      if (!this.step || !this.visible?.length) return 0;
      const index = Math.round((this.track.scrollLeft - (this.loopStart || 0)) / this.step);
      return ((index % this.visible.length) + this.visible.length) % this.visible.length;
    }
    makeClone(card, side, index) {
      const clone = card.cloneNode(true);
      clone.removeAttribute('data-review');
      clone.removeAttribute('data-block-id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.dataset.reviewClone = side;
      clone.setAttribute('aria-hidden', 'true');
      const ids = new Map();
      clone.querySelectorAll('[id]').forEach(element => {
        const id = element.id + '--' + side + '-' + index;
        ids.set(element.id, id);
        element.id = id;
      });
      clone.querySelectorAll('[aria-controls]').forEach(element => {
        const id = ids.get(element.getAttribute('aria-controls'));
        if (id) element.setAttribute('aria-controls', id);
      });
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
      return clone;
    }
    buildLoop(index = 0) {
      clearTimeout(this.settleTimer);
      this.moving = false;
      this.removeClones();
      this.visible = this.cards.filter(card => !card.hidden);
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = this.visible[0]?.getBoundingClientRect().width || 0;
      this.step = width + gap;
      this.loopLength = this.visible.length * this.step;
      this.looping = this.dataset.loop !== 'false' && this.visible.length > 1 && this.loopLength - gap > this.track.clientWidth + 1;
      if (this.looping) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.visible.forEach((card, i) => {
          before.append(this.makeClone(card, 'before', i));
          after.append(this.makeClone(card, 'after', i));
        });
        this.track.prepend(before);
        this.track.append(after);
      }
      this.loopStart = this.looping ? this.loopLength : 0;
      this.track.scrollTo({left: this.loopStart + Math.min(index, Math.max(this.visible.length - 1, 0)) * this.step, behavior: 'instant'});
      this.geometryKey = this.measureKey();
      this.updateArrows();
    }
    filter(button, announce = true) {
      this.cancelReviewAnimations();
      this.removeClones();
      const normalize = value => value.trim().toLocaleLowerCase();
      const mode = button.dataset.filter;
      const tag = normalize(button.dataset.tag || '');
      this.filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.cards.forEach(card => {
        const tags = (card.dataset.tags || '').split(',').map(normalize).filter(Boolean);
        const match = mode === 'all' || (mode === 'photo' && card.dataset.photo === 'true') || (mode === 'rating' && Number(card.dataset.score) === Number(button.dataset.score)) || (mode === 'tag' && tag !== '' && tags.includes(tag));
        card.hidden = !match;
      });
      const count = this.cards.filter(card => !card.hidden).length;
      this.querySelector('[data-empty]').hidden = count > 0;
      this.track.hidden = count === 0;
      this.buildLoop(0);
      if (announce) this.status.textContent = this.status.dataset.template.replace('[count]', String(count));
      this.updateReadMore();
      if (announce) {
        this.revealObserver?.disconnect();
        this.animateReviews();
      }
    }
    move(direction) {
      if (!this.visible.length || this.moving) return;
      const index = Math.round((this.track.scrollLeft - this.loopStart) / this.step);
      this.moving = true;
      this.track.scrollTo({left: this.loopStart + (index + direction) * this.step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.finishScroll(), 180);
    }
    finishScroll() {
      if (this.dragging) return;
      clearTimeout(this.settleTimer);
      if (this.looping) {
        const offset = this.track.scrollLeft - this.loopStart;
        if (offset < -1 || offset >= this.loopLength - 1) {
          const normalized = ((offset % this.loopLength) + this.loopLength) % this.loopLength;
          this.track.scrollTo({left: this.loopStart + normalized, behavior: 'instant'});
        }
      }
      this.moving = false;
      this.updateArrows();
    }
    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.hidden || (!this.looping && this.track.scrollLeft <= 2);
      this.next.disabled = this.track.hidden || (!this.looping && this.track.scrollLeft >= max - 2);
    }
    updateReadMore() {
      this.querySelectorAll('.rqst-testimonials__card:not([hidden])').forEach(card => {
        const body = card.querySelector('[data-body]');
        const button = card.querySelector('[data-read-more]');
        button.hidden = !body.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 1;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vagavi-collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionCleanups = new WeakMap();

    function setup(root) {
      if (root.dataset.vcsReady) return;
      root.dataset.vcsReady = 'true';
      const controller = new AbortController();
      let revealObserver = null;
      let unloaded = false;
      const panels = Array.from(root.querySelectorAll('[data-vcs-panel]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        const revealPanel = (panel) => {
          panel.querySelectorAll('.vcs__card--awaiting').forEach((card) => card.classList.add('vcs__card--visible'));
        };
        revealObserver = 'IntersectionObserver' in window
          ? new IntersectionObserver((entries) => {
              if (unloaded) return;
              entries.forEach((entry) => {
                if (entry.isIntersecting && !entry.target.hidden) {
                  revealPanel(entry.target);
                  revealObserver.unobserve(entry.target);
                }
              });
            }, { threshold: .05 })
          : null;
        panels.forEach((panel) => {
          panel.querySelectorAll('.vcs__card').forEach((card, index) => {
            card.style.setProperty('--vcs-enter-delay', `${Math.min(index, 7) * 150}ms`);
            card.classList.add('vcs__card--awaiting');
          });
          if (revealObserver) revealObserver.observe(panel);
          else revealPanel(panel);
        });
      }

      function updateArrows(panel) {
        const track = panel.querySelector('[data-vcs-track]');
        const arrows = panel.querySelector('[data-vcs-arrows]');
        const footer = panel.querySelector('[data-vcs-footer]');
        if (!track || !arrows) return;
        const overflow = track.scrollWidth > track.clientWidth + 2;
        arrows.hidden = !overflow;
        if (footer) footer.hidden = !overflow && !footer.querySelector('.vcs__view-all');
        const previous = arrows.querySelector('[data-vcs-prev]');
        const next = arrows.querySelector('[data-vcs-next]');
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      panels.forEach((panel) => {
        const track = panel.querySelector('[data-vcs-track]');
        if (!track) return;
        track.addEventListener('scroll', () => updateArrows(panel), { passive: true, signal: controller.signal });
        panel.querySelector('[data-vcs-prev]')?.addEventListener('click', () => {
          const card = track.querySelector('.vcs__card');
          if (card) track.scrollBy({ left: -(card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: 'smooth' });
        }, { signal: controller.signal });
        panel.querySelector('[data-vcs-next]')?.addEventListener('click', () => {
          const card = track.querySelector('.vcs__card');
          if (card) track.scrollBy({ left: card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap), behavior: 'smooth' });
        }, { signal: controller.signal });
      });

      const onResize = () => {
        const active = panels.find((panel) => !panel.hidden);
        if (active) updateArrows(active);
      };
      window.addEventListener('resize', onResize);
      const active = panels.find((panel) => !panel.hidden);
      const initialFrame = active ? requestAnimationFrame(() => updateArrows(active)) : null;
      sectionCleanups.set(root, () => {
        unloaded = true;
        controller.abort();
        window.removeEventListener('resize', onResize);
        revealObserver?.disconnect();
        if (initialFrame !== null) cancelAnimationFrame(initialFrame);
        delete root.dataset.vcsReady;
      });
    }

    function setupAll(container) {
      container.querySelectorAll('[data-vcs-section]').forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll(document));
    else setupAll(document);
    document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-vcs-section]').forEach((root) => {
        sectionCleanups.get(root)?.();
        sectionCleanups.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
